import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

export const DynamicThemePromo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="group relative">
      <button
        type="button"
        aria-label={t('home.dynamicThemePromo.label')}
        aria-describedby="dynamic-theme-promo-tooltip"
        className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-white/10 text-amber-200 backdrop-blur-sm transition-colors hover:bg-white/20 hover:text-amber-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
      >
        <Sparkles className="h-4 w-4" aria-hidden="true" />
      </button>
      <div
        id="dynamic-theme-promo-tooltip"
        role="tooltip"
        className="pointer-events-none absolute bottom-full right-0 mb-2 w-64 max-w-[calc(100vw-2rem)] translate-y-1 rounded-lg border border-white/10 bg-slate-900/95 px-3 py-2 text-xs leading-relaxed text-slate-100 opacity-0 shadow-lg transition-all duration-150 group-focus-within:translate-y-0 group-focus-within:opacity-100 group-hover:translate-y-0 group-hover:opacity-100"
      >
        <p className="font-semibold text-amber-200">{t('home.dynamicThemePromo.title')}</p>
        <p className="mt-0.5 text-slate-300">{t('home.dynamicThemePromo.description')}</p>
      </div>
    </div>
  );
};
